import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import FlowPublic from "./pages/FlowPublic";
import AnalyticsDashboard from "./pages/AnalyticsDashboard";
import ExportDashboard from "./pages/ExportDashboard";
import DashboardPasswordGate from "./components/DashboardPasswordGate";
import { useTripleWhalePageView } from "./hooks/useTripleWhalePageView";
import { useEffect } from "react";
import { captureTrackingParams } from "./lib/tracking";

const queryClient = new QueryClient();

const AppContent = () => {
  useTripleWhalePageView();
  useEffect(() => {
    captureTrackingParams();
  }, []);
  return (
    <>
    <Routes>
      <Route path="/" element={<FlowPublic />} />
      <Route path="/dashboard" element={<DashboardPasswordGate><AnalyticsDashboard /></DashboardPasswordGate>} />
      <Route path="/export" element={<DashboardPasswordGate><ExportDashboard /></DashboardPasswordGate>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  );
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
